import { CountriesState } from '../state'
import { Country } from '@spartacus/core'
import { MbSiteContextActions } from '../actions'

export const initialState: CountriesState = {
  entities: {},
  activeCountry: '',
}

export function reducer (
  state = initialState,
  action: MbSiteContextActions.CountriesActions
) {
  switch (action.type) {
    case MbSiteContextActions.LOAD_COUNTRIES_SUCCESS: {
      const entities = action.payload.reduce(
        (countryEntities: { [isocode: string]: Country }, country: Country) => ({
          ...countryEntities,
          [(country?.isocode as string)]: country,
        }),
        {
          ...state.entities,
        }
      )
      return {
        ...state,
        entities,
      }
    }
    case MbSiteContextActions.SET_ACTIVE_COUNTRY: {
      return {
        ...state,
        activeCountry: action.payload,
      }
    }
  }
  return state
}
